import React, { forwardRef } from 'react';

import { Stack } from 'Modules/ui3';

import { BodyRow, BodyRowProps } from '../BodyRow';
import { EmissionItem } from '../../../api';
import { WithOnScroll } from '../types';
import { Loader } from '../../ui/loaders';


export interface BodyProps extends Omit<BodyRowProps, 'data'>, WithOnScroll {
    data: EmissionItem[];
    showLoader?: boolean;
}

export const Body = forwardRef<HTMLDivElement, BodyProps>((
    { data, isDesktop, onScroll, showLoader, ...props }, ref,
) => showLoader ? <Loader /> : (
    <Stack
        ref={ref}
        flex={1}
        mt={isDesktop ? 6 : 4}
        height='100%'
        spacing={isDesktop ? 6 : 4}
        overflow='auto'
        onScroll={onScroll}
        sx={{
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',

        }}
    >
        {data.map((rowData, index) => (
            <BodyRow
                key={`row_${index}`}
                data={rowData}
                isDesktop={isDesktop}
                {...props}
            />
        ))}
    </Stack>
));
